module.exports = __webpack_public_path__ + "img/icon1-2.f59fda09.png";